import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../../tas';

export default class AuthenticatedCareerPathwaysTasProgramsNewRoute extends Route {
  model(params: Record<string, unknown>) {
    const programId = params['tas_program_instance_id'] as string;
    return {
      ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
      programId,
    };
  }
}
